export type NotificationApiHandle =
  | `/settings`
  | `/settings/${string}`
  | `/version`
  | `/reset`
  | `/amtool/config`
  | `/alertmanager/config`
  | `/alertmanager/config/restore`
  | `/alertmanager/config/refresh`
  | `/global_config`
  | `/inhibit_rules`
  | `/template_config`
  | `/receivers`
  | `/receiver/${string}`
  | `/receiver`
  | `/routes/${string}`
  | `/route/${string}`
  | `/route`
  | `/senders`
  | `/sender/${string}`
  | `/sender`
  | `/time_intervals`
  | `/time_interval/${string}`
  | `/time_interval`
  | `/template`
  | `/personal_notification`
  | `/admin/routes`
  | `/admin/receivers`
  | `/admin/routes/enabled`
  | `/admin/receiver/${string}`
  | `/`;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface NotificationInstance extends AxiosInstance {
  get<T = any, R = AxiosResponse<T>, P extends string = NotificationApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  delete<
    T = any,
    R = AxiosResponse<T>,
    P extends string = NotificationApiHandle,
  >(url: P, config?: AxiosRequestConfig): Promise<R>;
  post<T = any, R = AxiosResponse<T>, P extends string = NotificationApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  put<T = any, R = AxiosResponse<T>, P extends string = NotificationApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
}

import axios from 'axios';
import { AXIOS_NO_CACHE_HEADERS } from '@/shared/api/no-cache-headers';
import i18n from '@/shared/config/i18n';

export const notificationInstance = axios.create({
  baseURL: '/api/notification/v3',
  headers: AXIOS_NO_CACHE_HEADERS,
}) as NotificationInstance;

i18n.on('languageChanged', (lng) => {
  notificationInstance.defaults.headers.common['Accept-Language'] = lng;
});